import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import { useNavigate } from 'react-router-dom';

export default function Page404() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(160deg, #f0f4ff 0%, #e8edf8 100%)',
        p: 3,
        textAlign: 'center',
      }}
    >
      {/* 404 with bus icon overlaid */}
      <Box sx={{ position: 'relative', mb: 5 }}>
        <Typography
          sx={{
            fontSize: { xs: '7rem', sm: '11rem', md: '14rem' },
            fontWeight: 900,
            lineHeight: 1,
            letterSpacing: '-0.04em',
            background: 'linear-gradient(135deg, #1565c0 0%, #42a5f5 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            userSelect: 'none',
            opacity: 0.15,
          }}
        >
          404
        </Typography>

        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
          }}
        >
          <DirectionsBusIcon
            sx={{
              fontSize: { xs: 64, sm: 96 },
              color: 'primary.main',
            }}
          />
          <Typography
            sx={{
              fontSize: { xs: '1.1rem', sm: '1.4rem' },
              fontWeight: 800,
              color: 'primary.main',
              letterSpacing: '0.25em',
              textTransform: 'uppercase',
            }}
          >
            Page not found
          </Typography>
        </Box>
      </Box>

      <Typography
        variant="h5"
        fontWeight={700}
        color="text.primary"
        gutterBottom
      >
        This stop doesn't exist
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ maxWidth: 400, mb: 4, lineHeight: 1.7 }}
      >
        Looks like this bus took a wrong turn. The page you're looking for has
        been moved, deleted, or never existed.
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/')}
          sx={{ borderRadius: 2, px: 5, fontWeight: 600 }}
        >
          Go Home
        </Button>
        <Button
          variant="outlined"
          size="large"
          onClick={() => navigate(-1)}
          sx={{ borderRadius: 2, px: 5, fontWeight: 600 }}
        >
          Go Back
        </Button>
      </Stack>
    </Box>
  );
}
